import {Injectable} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {FormGroupFactory} from '@api/common';

export interface NoteFormValues {
  note: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class NoteFormGroupFactory extends FormGroupFactory {

  private readonly defaultValues: NoteFormValues = {
    note: null,
  };

  create(predefinedValues?: Partial<NoteFormValues>): FormGroup {
    const formGroup = new FormGroup({
      note: new FormControl<string | null>(this.defaultValues.note),
    });

    if (predefinedValues) this.updateFormGroupValues(formGroup, predefinedValues);

    return formGroup;
  }

}
